import sumBy from "lodash/sumBy";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showLoader, hideLoader } from "store/misc/loaderSlice";
import { showMessage } from "store/misc/messageSlice";
import deliveryMethodService from "services/deliveryMethodService";

export const getDeliveryMethods = createAsyncThunk(
	"vino/deliveryMethods/list",
	async (checkoutId, { dispatch, rejectWithValue }) => {
		try {
			dispatch(showLoader());
			const deliveryMethods = await deliveryMethodService.list(checkoutId);
			return deliveryMethods;
		} catch (err) {
			console.error(err);
			dispatch(
				showMessage({
					message: "Error occurred while getting shipping methods",
					variant: "error",
				})
			);
			return rejectWithValue(err.response.data);
		} finally {
			dispatch(hideLoader());
		}
	}
);

const deliveryMethodsSlice = createSlice({
	name: "vino/deliveryMethods",
	initialState: {
		list: [],
	},
	reducers: {
		resetDeliveryMethods: (state) => {
			state.list = [];
		},
	},
	extraReducers: {
		[getDeliveryMethods.fulfilled]: (state, action) => {
			state.list = action.payload;
		},
	},
});

export const { resetDeliveryMethods } = deliveryMethodsSlice.actions;

export default deliveryMethodsSlice.reducer;
